import React, {useEffect, useState} from 'react';
import {Button, Card, Input, List} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useParams} from "react-router-dom";
import {useFormik} from "formik";
import {ErrorMessageWidget} from "@/components/form/errorMessageWidget";
import toFaNumber from "@/lib/utils/number";
import {
    useApiCreateAdminPollQuestionOption,
    useApiDeleteAdminPollQuestionOptions,
    useApiReadAdminPollQuestionOption,
    useApiUpdateAdminPollQuestionOption
} from "@/api/questionOptions";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

function EditOptionSection({options, questionId}) {

    const param = useParams()
    const survey_id = param.id;

    const [myOptions, setMyOptions] = useState(options)

    const {data, isPending: isPendingGet, isRefetching, refetch} = useApiReadAdminPollQuestionOption(questionId)

    const {mutate: addOption, isPending: isPendingAdd} = useApiCreateAdminPollQuestionOption()
    const {mutate: editOption, isPending: isPendingEdit} = useApiUpdateAdminPollQuestionOption()

    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {


            values.survey_id = survey_id
            values.question_id = questionId


            addOption({question_id: questionId, data: values},
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                        formik.resetForm()
                        refetch().then(r => {
                        })


                    },
                    onError: (res) => {
                        ApiHandleErrorMessage(res)
                    },
                })


        }
    })

    useEffect(() => {

        setMyOptions(data?.data?.data)
    }, [data, questionId, survey_id]);


    useEffect(() => {
        formik.setFieldValue('title', options?.title)
        formik.setFieldValue('description', options?.description)
        formik.setFieldValue('type', options?.type)

    }, [options, survey_id]);


    function addPollDefaultOption() {
        const defaultOptions = [
            {
                title: 'عالی',
                sort: 5,
                score: 5,
            },
            {
                title: 'خوب',
                score: 4,
                sort: 4,
            },
            {
                title: 'متوسط',
                score: 3,
                sort: 3,
            },
            {
                title: 'ضعیف',
                score: 2,
                sort: 2,
            },
            {
                title: 'خیلی ضعیف',
                score: 1,
                sort: 1,
            }

        ]

        defaultOptions.map((option) => {
            addOption({question_id: questionId, data: {...option, survey_id: survey_id, question_id: questionId}}, {})
        })

        setTimeout(refetch, 1500)

    }


    return (
        <>
            <Card>
                <div className="flex justify-between">
                    <Can permission={PermList.SURVEY_EDIT}>
                        <div className="flex gap-1">
                            <div className={'mt-1 font-bold'}>افزودن گزینه جدید</div>
                            <div className={`flex flex-col gap-1`}>

                                <Input placeholder={"عنوان گزینه"}
                                       disabled={isPendingAdd}
                                       value={formik.values.title}
                                       status={formik.errors.title && "error"}
                                       onChange={(e) => formik.setFieldValue("title", e.target.value)}
                                />
                                {formik.errors.title && <ErrorMessageWidget message={formik.errors.title}/>}
                            </div>
                            <div className={`flex flex-col gap-1`}>

                                <Input placeholder={"امتیاز گزینه را وارد کنید"}
                                       disabled={isPendingAdd}
                                       value={formik.values.score}
                                       status={formik.errors.score && "error"}
                                       onChange={(e) => formik.setFieldValue("score", e.target.value)}
                                />
                                {formik.errors.score && <ErrorMessageWidget message={formik.errors.score}/>}
                            </div>
                            <Button onClick={formik.submitForm} loading={isPendingAdd}
                            >
                                {'ثبت'}
                            </Button>
                        </div>
                    </Can>
                    <div className={'mt-4 gap-1'}>
                        {(!myOptions || myOptions.length === 0) && <Button onClick={addPollDefaultOption}
                                                                           loading={isPendingAdd}
                                                                           type={'dashed'} size={'small'}>افزودن
                            گزینه‌های نظرسنجی</Button>}

                    </div>
                </div>

                <div>

                    {myOptions && myOptions.length > 0 && (<>
                            <hr className={'my-2'}/>
                            <div className={'mt-1 font-bold'}>لیست گزینه ها</div>

                            <List
                                className="demo-loadmore-list"
                                loading={isPendingGet || isRefetching}
                                itemLayout="horizontal"

                                dataSource={myOptions}
                                renderItem={(item) => (
                                    <List.Item
                                        actions={[
                                            <DeleteOptionButtonCMP id={item?.id} questionId={questionId}
                                                                   refetch={refetch}/>
                                        ]}
                                    >

                                        <List.Item.Meta
                                            title={item?.title}
                                            description={item?.score ? ' امتیاز ' + toFaNumber(item.score) : ''}
                                        />


                                    </List.Item>
                                )}
                            />
                        </>
                    )}
                </div>

            </Card>


        </>
    );
}

export default EditOptionSection;


function DeleteOptionButtonCMP({questionId, id, refetch}) {
    const [isDeleted, setIsDeleted] = useState(false)
    const {mutate: deleteOption, isPending: isPendingDelete} = useApiDeleteAdminPollQuestionOptions()

    function deleteOptionFn(id) {
        deleteOption({option_id: id, question_id: questionId}, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res)
                setIsDeleted(true)
                refetch().then(r => {
                })


            },
            onError: (res) => {
                ApiHandleErrorMessage(res)
            },
        })
    }


    return (<Button size={"small"} danger variant={'text'}
                    onClick={() => deleteOptionFn(id)} loading={isPendingDelete}>
        حذف
    </Button>)
}